

export const GENERATE_VIDEO = 'GENERATE_VIDEO';
export const VIDEO_GENERATION_IN_PROGRESS = 'VIDEO_GENERATION_IN_PROGRESS';
export const GET_VIDEO_GENERATED = 'GET_VIDEO_GENERATED';